import { Controller } from "@hotwired/stimulus"
import { apiHeaders, htmlHeaders, notifyOfflineWrite, responseErrorMessage, showFormError, writeFetch } from "./sweeper_shared"

export default class extends Controller {
  static values = {
    url: String,
    formUrl: String
  }

  connect() {
    this.onActivated = this.render.bind(this)
    document.addEventListener("sweeper:programma-activated", this.onActivated)
  }

  disconnect() {
    document.removeEventListener("sweeper:programma-activated", this.onActivated)
  }

  new() {
    this.openForm(null)
  }

  async row(event) {
    const actionButton = event.target.closest("[data-programma-action]")
    if (!actionButton) return

    const id = parseInt(actionButton.dataset.id, 10)
    if (!Number.isFinite(id)) return

    if (actionButton.dataset.programmaAction === "edit") {
      this.openForm({ id })
    } else if (actionButton.dataset.programmaAction === "delete") {
      this.delete(id)
    }
  }

  async render() {
    if (this.element.getAttribute("src") === this.urlValue && typeof this.element.reload === "function") this.element.reload()
    else this.element.setAttribute("src", this.urlValue)
  }

  async openForm(existing) {
    this.content.innerHTML = '<div class="empty-state">Laden...</div>'
    const url = new URL(this.formUrlValue, window.location.origin)
    if (existing?.id) url.searchParams.set("id", existing.id)
    const response = await fetch(url, {
      credentials: "include",
      headers: htmlHeaders("view-programma")
    })
    if (!response.ok) {
      this.content.innerHTML = '<div class="empty-state">Formulier laden mislukt.</div>'
      return
    }

    this.content.innerHTML = await response.text()
    document.getElementById("si-cancel").addEventListener("click", () => this.render())
    document.getElementById("si-save").addEventListener("click", () => this.saveForm())
  }

  async saveForm() {
    const id = document.getElementById("si-id")?.value
    const date = document.getElementById("si-date").value
    const startTime = document.getElementById("si-start").value
    const endTime = document.getElementById("si-end").value
    const sessionUid = document.getElementById("si-session").value
    const title = document.getElementById("si-title").value.trim()
    const continuous = document.getElementById("si-continuous")?.checked || false

    if (!startTime || !endTime) return showFormError("si-error", "Start- en eindtijd zijn verplicht")
    if (!sessionUid && !title) return showFormError("si-error", "Kies een sessie of geef een titel op")

    const payload = {
      starts_at: `${date}T${startTime}:00`,
      ends_at: `${date}T${endTime}:00`,
      room_id: document.getElementById("si-room").value || null,
      sweeper_session_id: sessionUid || null,
      title: title || null,
      notes: document.getElementById("si-notes").value,
      continuous
    }
    const response = await writeFetch(id ? `/api/v1/scheduled_items/${id}` : "/api/v1/scheduled_items", {
      method: id ? "PATCH" : "POST",
      credentials: "include",
      headers: apiHeaders(),
      body: JSON.stringify(payload)
    })
    if (!response.ok) {
      showFormError("si-error", await responseErrorMessage(response, "Opslaan mislukt"))
      return
    }
    this.render()
  }

  async delete(id) {
    if (!confirm("Item verwijderen?")) return
    const response = await writeFetch(`/api/v1/scheduled_items/${id}`, {
      method: "DELETE",
      credentials: "include",
      headers: apiHeaders()
    })
    if (!response.ok) return notifyOfflineWrite()

    this.render()
  }

  get content() {
    return document.getElementById("programma-content")
  }
}
